import { AuftragSpeichernRueckgabe } from "./Auftrag";
import { /*Preisanfrage,*/ PreisanfrageRueckgabe } from "./Preisanfrage";

export enum Environment {
    PROD = "prod",
    TEST = "test",
    DUMMY = "dummy",
    DEVPROD = "devProd",
    DEVTEST = "devTest",
}

enum Webservice {
    PREIS_BERECHNEN = "PreisBerechnen",
    AUFTRAG_SPEICHERN = "AuftragSpeichern",
}

export type WebserviceEnvironment = {
    [ws in Webservice] : {
        url : string;
        fnData : Function;
    }
}


type WebserviceEnvironmentMap = {
    [env in Environment] : WebserviceEnvironment;
}

export const webserviceEnvironmentMap : WebserviceEnvironmentMap = {
    prod: {
        PreisBerechnen : {
            url : "https://resi.ruedinger.de/tmpResiPreisBerechnen.brick?action=preisBerechnen",
            fnData: (data: any) => {
                console.log("Prod-Environment - Rückgabe PreisBerechnen:");
                //console.log(JSON.parse(data.data));
                //console.log(data);
                const ret : PreisanfrageRueckgabe = data;
                return ret;
            },
        },
        AuftragSpeichern : {
            url : "https://resi.ruedinger.de/tmpResiPreisBerechnen.brick?action=auftragSpeichern",
            fnData: (data: any) => {
                console.log("Prod-Environment - Rückgabe AuftragSpeichern:");
                //console.log(JSON.parse(data.data));
                //console.log(data);
                const ret : AuftragSpeichernRueckgabe = data;
                return ret;
            },
        },
    },
    test: {
        PreisBerechnen : {
            url : "",
            fnData: function(test : string){},
        },
        AuftragSpeichern : {
            url : "",
            fnData: function(test : string){},
        },
    },
    devProd: {
        PreisBerechnen : {
            url : "http://10.250.0.87:28090/tmpResiPreisBerechnen.brick?action=preisBerechnen",
            fnData: (data: any) => {
                console.log("Dev-Environment - Rückgabe PreisBerechnen:");
                //console.log(JSON.parse(data.data));
                console.log(data);
                const ret : PreisanfrageRueckgabe = data;
                return ret;
            },
        },
        AuftragSpeichern : {
            url : "http://10.250.0.87:28090/tmpResiPreisBerechnen.brick?action=auftragSpeichern",
            fnData: (data: any) => {
                console.log("Dev-Test-Environment - Rückgabe AuftragSpeichern:");
                //console.log(JSON.parse(data.data));
                console.log(data);
                const ret : AuftragSpeichernRueckgabe = data;
                return ret;
            },
        },
    },
    devTest: {
        PreisBerechnen : {
            url : "http://10.250.0.87:28090/tmpResiPreisBerechnenTest.brick?action=preisBerechnen",
            fnData: (data: any) => {
                console.log("Dev-Test-Environment - Rückgabe PreisBerechnen:");
                //console.log(JSON.parse(data.data));
                console.log(data);
                const ret : PreisanfrageRueckgabe = data;
                return ret;
            },
        },
        AuftragSpeichern : {
            url : "http://10.250.0.87:28090/tmpResiPreisBerechnenTest.brick?action=auftragSpeichern",
            fnData: (data: any) => {
                console.log("Dev-Test-Environment - Rückgabe AuftragSpeichern:");
                //console.log(JSON.parse(data.data));
                console.log(data);
                const ret : AuftragSpeichernRueckgabe = data;
                return ret;
            },
        },
    },
    dummy: {
        PreisBerechnen : {
            url : "http://10.74.238.235:8088/anything",
            fnData: (data: any) => {
                console.log("Dummy-Environment - Rückgabe PreisBerechnen:");
                console.log(JSON.parse(data.data));
                const ret : PreisanfrageRueckgabe = {preis: {gesamt : {bez: "Gesamt", wert: 101}, tv : {bez: "Transportversicherung", wert: 11},
                transport : {bez: "Transport", wert: 80}, ust : {bez: "Umsatzsteuer", wert: 20}, gesamtUst : {bez: "Gesamt", wert: 120}}, fehler : null};
                return ret;
            },
        },
        AuftragSpeichern : {
            url : "http://10.74.238.235:8088/anything",
            fnData: (data: any) => {
                console.log("Dummy-Environment - Rückgabe AuftragSpeichern:");
                console.log(JSON.parse(data.data));
                const ret : AuftragSpeichernRueckgabe = {preis: {gesamt : {bez: "Gesamt", wert: 100}}, fehler : null, referenz: "RESI00044"};
                return ret;
            },
        },
    },
}

//export const webserviceEnvironmentProd 